module.exports = __webpack_public_path__ + "img/map_all_exclusive-party-areas.2381ec4d.jpg";